import {
  buildTppWebFormsApiWithToken,
  CreateTppWebFormV2ParamsDisplayModeEnum,
  CreateTppWebFormV2ParamsMultibankingApiProviderEnum,
  CreateTppWebFormV2ParamsOperationEnum,
} from "@bn/api/apiv1";
import { MultibankingApiProvider } from "@api/v1/model/bankWrapper";
import { getAppUrlSufix } from "./mainAppUrls";

export const createAndRedirectToTppWebForm = async ({
  provider,
  bankSlug,
  bankConnectionId,
  displayMode,
  operation,
  returnUrl,
}: {
  provider: MultibankingApiProvider;
  bankSlug?: string;
  bankConnectionId?: number;
  displayMode?: CreateTppWebFormV2ParamsDisplayModeEnum;
  operation?: CreateTppWebFormV2ParamsOperationEnum;
  returnUrl?: string | null;
}) => {
  const api = await buildTppWebFormsApiWithToken();

  const multibankingApiProvider =
    provider === "WEALTH_API"
      ? CreateTppWebFormV2ParamsMultibankingApiProviderEnum.WEALTH_API
      : CreateTppWebFormV2ParamsMultibankingApiProviderEnum.FIN_API;

  const baseUrl = import.meta.env.VITE_APP_APP_URL;
  const redirectUrl = returnUrl
    ? `${baseUrl}${returnUrl}`
    : `${baseUrl}${getAppUrlSufix()}`;

  const { data } = await api.v2CreateTppWebForm({
    createTppWebFormV2Params: {
      bankSlug,
      bankConnectionId,
      operation,
      multibankingApiProvider,
      redirectUrl,
      displayMode: displayMode || CreateTppWebFormV2ParamsDisplayModeEnum.LIGHT,
    },
  });

  window.location.replace(
    `${data.startWebFormFlowUrl.replace(
      "http://localhost:3000",
      import.meta.env.VITE_APP_APP_URL
    )}`
  );
};
